import { Environment } from '@pegasus/config';
import { ImageSize } from './config';
import { UrlSource } from './types';
export var isEnabled = function (config) { return function (name) {
    var value = config.enable[name];
    if (typeof value === 'undefined' && process.env.NODE_ENV === Environment.DEVELOPMENT) {
        // eslint-disable-next-line no-console
        console.log("Missing enable flag ".concat(name));
    }
    return !!value;
}; };
export var getUrl = function (config) { return function (name, hasLogo) {
    var _a, _b;
    // TODO: remove hasLogo option when we also switch Zebra images to Akamai
    var specialName = name;
    if (name === 'campaign') {
        var cheetahCampaign = UrlSource.CHEETAH_CAMPAIGN;
        specialName =
            !hasLogo &&
                (((_a = config.view.url.secure) === null || _a === void 0 ? void 0 : _a[cheetahCampaign]) || config.view.url[cheetahCampaign])
                ? cheetahCampaign
                : name;
    }
    return ((_b = config.view.url.secure) === null || _b === void 0 ? void 0 : _b[specialName]) || config.view.url[specialName];
}; };
export var getImage = function (config) {
    return function (path, width) {
        if (width === void 0) { width = ImageSize.Medium; }
        var prefix = getUrl(config)(UrlSource.ARTICLES);
        if (!path || !prefix) {
            return '';
        }
        return "".concat(prefix, "/").concat(path, "?imwidth=").concat(width);
    };
};
export var getVideo = function (config) { return function (path) {
    var prefix = getUrl(config)(UrlSource.ARTICLES_VIDEOS);
    return "".concat(prefix, "/").concat(path);
}; };
export var getCountryCode = function (config) { return function () {
    return config.countryCode;
}; };
export var getSwitchUrl = function (config) {
    return function () {
        return config.domain && config.domain.switchurl ? config.domain.switchurl : null;
    };
};
export var getSwitchUrlAppdomains = function (config) { return function () {
    var switchUrl = getSwitchUrl(config)();
    return switchUrl && switchUrl.appdomains ? switchUrl.appdomains : null;
}; };
export var getTimeConstants = function (config) { return function (count) {
    if (!config.timeRules) {
        return count;
    }
    var _a = config.timeRules, few = _a.few, many = _a.many;
    if (count === 1) {
        return count;
    }
    if (few && count >= few.min && count <= few.max) {
        return 2;
    }
    if (many && count >= many.min && count <= many.max) {
        return 3;
    }
    return count;
}; };
export var getCountryCodeForAppdomainId = function (config) { return function (appdomainId) {
    if (!config.locale || !config.locale[appdomainId]) {
        return 'DE';
    }
    var _a = config.locale[appdomainId].split('_')[0], languageCode = _a === void 0 ? '' : _a;
    return languageCode;
}; };
export var injectHelperFunctions = function (config) {
    return Object.assign(config, {
        isEnabled: isEnabled(config),
        getUrl: getUrl(config),
        getImage: getImage(config),
        getVideo: getVideo(config),
        getSwitchUrl: getSwitchUrl(config),
        getSwitchUrlAppdomains: getSwitchUrlAppdomains(config),
        getCountryCode: getCountryCode(config),
        getCountryCodeForAppdomainId: getCountryCodeForAppdomainId(config),
        getTimeConstants: getTimeConstants(config),
    });
};
